import React,{useState,useEffect}from 'react';
import styled from 'styled-components';
import TitleHeader from 'components/presenters/header/TitleHeader';
import CampaignFriend from 'components/peoplelist/CampaignFriend';
import Bottom_Modal_var3 from 'components/modal/Bottom_Modal_var3'
import TopModalbar from 'components/modal/TopModalbar'
import serverController from 'server/serverController'
import { useSelector } from 'react-redux';



// 하단 모달 창 리스트 
let modallist = [
  {
      text:"강제퇴장",
      color:"#de0000"
  }
]


export default function CampaignMemberListLayout({match}) {
  const userInfo = useSelector(state=>{ return state.userInfo});
  const [currentPostIndex , setCurrentPostIndex] = useState(0); 
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [lastNumber , setLastNumber] = useState(0);

  // 프로젝트 참여인원
  const [peoplelist , setPeopLeList] = useState([]);
  const memberCallBack=(jsonData)=>{
    if(jsonData.success !== 1){
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    }
    else
    {
      let receivedMember = jsonData.data.members;

      if(receivedMember.length === 0){
          setIsEnd(true);
      }
      else
      {
        let lastNo = receivedMember[receivedMember.length - 1].no
        setIsEnd(false);
        setLastNumber(lastNo);
      }

      setPeopLeList(jsonData.data.members);
    }
  }
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    serverController.getServerData(`campaigns/${match.params.id}/members`,memberCallBack);
  },[]);


  // 켐페인 상세
  const [groupInfo , setGroupInfo] = useState({});
  const detailinfoCallBack=(jsonData)=>{
    if(jsonData.success !== 1){
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    }
    else
    {
      setGroupInfo(jsonData.data);
    }
  }
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    serverController.getServerData(`campaigns/${match.params.id}`,detailinfoCallBack);
  },[]);

  //참여인원 강퇴하기
  const delcallBack  = (res) =>{
    if(res.success === 1){
        alert("성공")
        // window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("실패")
    }
  }

  /*--click block--*/
  var isclick = false;
  const delmemberSubmit = async () =>{

      if(isclick)
          return;
      isclick = true;
      var data = {};
      await  serverController.insertFilePostFetchController(`groups/${match.params.id}/members/${currentPostIndex}/block`,JSON.stringify(data),delcallBack);
      isclick = false;
  }


  //친구신청 하기
  const friendSubmitcallBack  = (res) =>{
    if(res.success === 1){
        // alert("성공")
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("예기치 못한 문제가 발생하였습니다.")
    }
  }

   /*--click block--*/
  const friendSubmit = async (indexOptional) => {
      if(isclick)
          return;
      isclick = true;

      var postIndex = indexOptional ? indexOptional : currentPostIndex
      let data = {};
      await serverController.insertFilePostFetchController(`friends/users/${postIndex}/requests`, JSON.stringify(data), friendSubmitcallBack);
      isclick = false;
  }

  // 친구신청 취소하기
  const friendsdeleteCallBack  = (res) =>{
    if(res.success === 1){
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("예기치 못한 문제가 발생하였습니다.")
    }
  }

  /*--click block--*/
  const frienddeleteSubmit= async (indexOptional)=> {
    if(isclick)
        return;
    isclick = true;

    let data = {};
    await serverController.updateFileDeleteFetchController(`friends/users/${currentPostIndex}/requests`,JSON.stringify(data),friendsdeleteCallBack);
    isclick = false;
  }

  // 친구 삭제하기
  const friendsdelCallBack  = (res) =>{
    if(res.success === 1){
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("예기치 못한 문제가 발생하였습니다.")
    }
  }
  
  /*--click block--*/
  const friendDelSubmit= async ()=> {
    if(isclick)
        return;
    isclick = true;

    let data = {};
    await serverController.updateFileDeleteFetchController(`friends/users/${currentPostIndex}`,JSON.stringify(data),friendsdelCallBack);
    isclick = false;
  }

  //친구신청 수락 하기
  const submitcallBack  = (res) =>{
    if(res.success === 1){
        // alert("성공")
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("예기치 못한 문제가 발생하였습니다.")
    }
  }

  /*--click block--*/
  const dataSubmit= async (indexOptional)=> {
      if(isclick)
          return;
      isclick = true;

      var postIndex = indexOptional ? indexOptional : currentPostIndex
      let data = {};
      await serverController.insertFilePostFetchController(`friends/users/${postIndex}/requests/result`, JSON.stringify(data), submitcallBack);
      isclick = false;
  }



  const [modalShow,setModalShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalTop, setShowModalTop] = useState(false);
  const [modalOption ,setModalOption] = useState("");

  const [reasonExit , setReasonExit] = useState("");


  const openModalExit = () => {
    modallist[0].clickEvent = () =>{
      setShowModal(true);
      setModalShow(false);
    };
  }

  openModalExit();

  

  const handleScroll = (e) => {
    try{
      const bottom = (e.target.scrollHeight - e.target.scrollTop - 100) <= e.target.clientHeight;
      if (bottom && !isEnd) { 
        if(!isLoading)
        {
          setIsLoading(true);
          serverController.getServerData(`campaigns/${match.params.id}/members?last_pos_no=${lastNumber}&limit=20`,function(res){
              if(!res || res.success !== 1 || res.data.members.length === 0){
                setIsEnd(true);
                return;
              }

              var tempList = JSON.parse(JSON.stringify(peoplelist));
              let receivedMemberList = res.data.members;
              setPeopLeList(tempList.concat(receivedMemberList));
              if(receivedMemberList.length === 0)
              {
                setIsEnd(true);
              }
              else
              {
                setIsEnd(false);
                setLastNumber(receivedMemberList[receivedMemberList.length - 1].no);
              }
              setIsLoading(false);
          });
        }
      }
    }
    catch(err)
    {
      console.log(err);
      setIsLoading(false);
    }
  }

  const clickSelector =  {
    "forcedExit" : [
        () => {setShowModal(true);setModalShow(false); delmemberSubmit(currentPostIndex);setModalOption("");},
    ],
    "friendcancel" : [
      () => {setShowModal(true);setModalShow(false); friendDelSubmit(currentPostIndex);setModalOption("");},
    ],
    "requestCancel" : [
      () => {setShowModal(true);setModalShow(false); frienddeleteSubmit(currentPostIndex);setModalOption("");},
    ],
  };

  return (
    <CampaignMemberListWrapper >
      <TitleHeader title={"참여인원"}  borderbottom={'1px solid #d5d5d5'}/>
      <FriendListInner onScroll={handleScroll}>
      {
        peoplelist.map((value)=>{
          return <CampaignFriend 
                    key={`campaign-member-list-item-${value['no']}`}
                    display={"block"} 
                    nickname={value.nickname}   
                    // friendlist={friendlist}
                    value={value}
                    userInfo={userInfo}
                    groupInfo={groupInfo}
                    currentPostIndex={currentPostIndex}
                    setCurrentPostIndex={setCurrentPostIndex}
                    setModalOption={setModalOption}
                    setModalShow={setModalShow}
                    friendSubmit={friendSubmit}
                    frienddeleteSubmit={frienddeleteSubmit}
                    dataSubmit={dataSubmit}
                  />
                  
        })
      }
        </FriendListInner>
      <Bottom_Modal_var3 
        modalShow={modalShow}    //모달 보여지는 여부
        setModalShow={setModalShow} 
        modalOption={modalOption}
        clickEventList={clickSelector[modalOption]}
        setModalOption={setModalOption}
        // currentPostIndex={currentPostIndex}
    />



      <TopModalbar top={"calc(100vw*(51/375))"} 
                  text={"영지버섯님이 강퇴되었습니다"}
                  showModalTop={showModalTop}
                  setShowModalTop={setShowModalTop}         
            />

    </CampaignMemberListWrapper>
  );
}

const CampaignMemberListWrapper = styled.div`
  overflow-y: scroll;
  height: 100vh;
`;
const FriendListInner = styled.div`
    padding-top: calc(100vw*(73.5/375));
`

